import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <span className="font-heading font-bold text-lg text-foreground-950 tracking-tight">
                AllChinaBuy<span className="text-primary-500">Spread</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer.disclaimer')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-sm text-foreground-950 uppercase tracking-wider">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                {t('footer.links.home')}
              </Link>
              <Link to="/article" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                {t('nav.shoppingGuide')}
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                {t('footer.links.guides')}
              </a>
            </div>
          </div>

          {/* Main Site CTA */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-sm text-foreground-950 uppercase tracking-wider">
              Main Website
            </h4>
            <p className="text-sm text-foreground-600">
              Visit our main website for the full AllChinaBuy spreadsheet experience.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Visit kaspreadsheet.com
              <i className="ri-external-link-line" />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 text-center">
          <p className="text-xs text-foreground-500">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}